import React, { useState, useEffect } from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DonationPage from './pages/DonationPage';
import LeaderboardPage from './pages/LeaderboardPage';
import AdminPage from './pages/AdminPage';
import SignInPage from './pages/SignInPage';
import MediaPage from './pages/MediaPage';
import SponsorsPage from './pages/SponsorsPage';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // A simple, non-critical GET request to "wake up" the active Render backend
    fetch('https://server-ojqx.onrender.com/api/teachers')
      .then(res => console.log('Backend ping successful!'))
      .catch(err => console.error('Error pinging backend:', err));
  }, []); 
  
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    setIsAuthenticated(!!token);
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleSignOut = () => {
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
  };
const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-brand">Manorhaven Move-a-Thon</div>
        
        <button 
          className="hamburger-btn" 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          {menuOpen ? '✕' : '☰'}
        </button>

        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/" onClick={() => setMenuOpen(false)} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>Home</NavLink>
          <NavLink to="/media" onClick={() => setMenuOpen(false)} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>Media</NavLink>
          <NavLink to="/donate" onClick={() => setMenuOpen(false)} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>Donate</NavLink>
          <NavLink to="/sponsors" onClick={() => setMenuOpen(false)} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>Sponsors</NavLink>
          <NavLink to="/leaderboard" onClick={() => setMenuOpen(false)} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>Leaderboard</NavLink>
        </div>
      </nav>
      <main className="content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/donate" element={<DonationPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route
            path="/admin"
            element={
              isAuthenticated ? (
                <AdminPage onSignOut={handleSignOut} />
              ) : (
                <Navigate to="/signin" replace />
              )
            }
          />
          <Route path="/signin" element={<SignInPage onLoginSuccess={handleLoginSuccess} />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;